import { FontAwesomeIcon } from "./FontAwesomeIcon"
import { faDharmachakra } from "@fortawesome/free-solid-svg-icons"

export const Dharmachakra = (props) => {
  return <FontAwesomeIcon faIcon={faDharmachakra} {...props} />
}
